module.exports = "/_next/static/images/dollaralt-2694badf3db02f9db8e5e1682a9dc90e.svg";